// const { APP_VERSION } = require("../../appconfig/info");

// Firebase
exports.PROJECT_ID = "pnoistor";

exports.VER_TAG = "ver";

const getVersionFromURL = () => {
	let parsee = window.location.search;
	let version = new URLSearchParams(parsee).get(this.VER_TAG);
	if (!(version && this.VERSION_LIST.includes(version))) {
		version = this.VERSION_LIST.at(-1);
	}
	localStorage.setItem(this.VER_TAG, version);
	return version;
};

// Version code
exports.VERSION_LIST = [
	"oct07", 
	"dec01", 
	"feb2023", 
	"apr2023", 
	"may2023", 
	"jun2023",
	"jan2024",
	"apr2024",
	"may2024",
];
exports.VERSION = getVersionFromURL();

// Auth
exports.AUTH_DOM = "pnoistor.spr";

// Firestore
exports.DATABASE_URL = "";
exports.SUBJECT_UUID_LEN = 8;
exports.SUBJECT_COLLECTION = `subjects_${this.VERSION}`;
exports.SUBJECT_COLLECTIONS = this.VERSION_LIST.map((ver) => `subjects_${ver}`);

exports.CONTENT_COLLECTION = "content";
exports.SURVEY_DOC = "survey";
exports.SURVEY_DOC_PATH = `/${this.CONTENT_COLLECTION}/${this.SURVEY_DOC}`;

// Storage
exports.FILENAME_SEP = "-";
exports.AUDIO_DATA_FOLDER = `${this.PROJECT_ID}_${this.VERSION}`;

// Content paths
exports.LOCAL_EXPORT_PATH = "./exports";
exports.SURVEY_PATH = "./src/app/appconfig/content/questions.js";
exports.SERVER_CONFIG_PATH = "./src/app/firebase/creds/.server-pnoistor.json";

exports.GUTIL_EXP = `gsutil -m cp -R gs://pnoistor.appspot.com/${this.PROJECT_ID}_${this.VERSION} ./`;
